import utils from '../libs/utils';
import axios from './axios';

const MODULE_NAME = 'v1/erp-business-web';
export default {
  axios,
  getAidInventoryList(params) { // 援助商品库存查询
    return axios.get(`${MODULE_NAME}/report/finance/in/list?${utils.exchangeParams(params)}`);
  },
  getAidSaleRecordList(params) { // 援助商品领用记录查询
    return axios.get(`${MODULE_NAME}/saleAid/listAidOrderDetail?${utils.exchangeParams(params)}`);
  },
  getAidSaleRecordTotal(params) { // 援助商品领用记录合计
    return axios.get(`${MODULE_NAME}/report/finance/in/total?${utils.exchangeParams(params)}`);
  },
  aidSaleRecordExport(params) { // 援助商品领用记录导出
    return axios.get(`${MODULE_NAME}/saleAid/listAidOrderDetail/download?${utils.exchangeParams(params)}`);
  },
  getAidApplyDetail(params) { // 援助申请单详情
    return axios.get(`${MODULE_NAME}/electronic/prescription/detailAid?${utils.exchangeParams(params)}`);
  },
  getAidApplyList(params) { // 援助申请单详情
    return axios.get(`${MODULE_NAME}/electronic/prescription/detailAid?${utils.exchangeParams(params)}`);
  },

};
